import { LoginSessionDecorator } from './LoginSessionDecorator'
import { TokenSessionDecorator } from '@/components/settings/integrations/decorators/TokenSessionDecorator.js'
import { SESSION_TYPES } from '@/components/settings/security/decorators/BaseSession.js'

export const SessionDecorator = (session) => {
  switch (session.type) {
    case SESSION_TYPES.LOGIN:
      return LoginSessionDecorator(session)
    case SESSION_TYPES.MANUAL:
      return TokenSessionDecorator(session)
  }
}
